module.exports = __webpack_public_path__ + "static/media/info.5691c7c9.svg";